import { Pipe, PipeTransform, inject } from '@angular/core';
import { ApplicationContextStore } from '../application-context/application-context.store';

/**
 * Pipe that resolves a structured translation key to its translated value.
 * Accepts a key object with feature, component, and label fields and looks up the
 * matching entry in the provided dictionary, falling back to storage when no dictionary
 * is passed. Returns an empty string when no match is found.
 */
@Pipe({
    name: 'translate',
})
export class TranslationPipe implements PipeTransform {
    private appContext = inject(ApplicationContextStore);
    private shouldIncludeOriginalLabel = this.appContext.shouldIncludeOriginalLabelInTranslation();

    /**
     * Translates the provided key into whatever language is currently active.
     * @param key - Structured key identifying the label to translate.
     * @param dictionary - Optional dictionary; overrides the dictionary from storage when provided.
     */
    transform(key: { feature: string; component: string; label: string }): string {
        const dictionary = this.appContext.dictionary();

        // If a dictionary is provided, use it to find the translation; otherwise, return the label as-is.
        if (dictionary && dictionary instanceof Map) {
            const composedKey = `${key.feature}|${key.component}|${key.label}`;
            const match = dictionary.get(composedKey);

            if (match) {
                if (match === key.label || !this.shouldIncludeOriginalLabel) {
                    return match;
                }

                return `${match}/${key.label}`;
            }
        }
        return key.label;
    }
}
